import { render } from "./FriendConnectPage.vue?vue&type=template&id=0ec6d08b"
import script from "./FriendConnectPage.vue?vue&type=script&lang=js"
export * from "./FriendConnectPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__